import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { standardOperators } from '../../Compounds/UpstackDataGrid/helpers';
import { usaCurrency } from '../../../utils/helpers';

export const DefaultLineItemGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'product',
    headerName: 'Product',
    sortable: true,
    width: 200,
    flex: 1,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'description',
    headerName: 'Description',
    sortable: true,
    width: 300,
    flex: 1,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'mrc',
    headerName: 'Monthly Cost',
    sortable: true,
    valueGetter: (value) => Number(value),
    valueFormatter: (value) => usaCurrency.format(value),
    width: 160,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'nrc',
    headerName: 'One Time Cost',
    sortable: true,
    valueGetter: (value) => Number(value),
    valueFormatter: (value) => usaCurrency.format(value),
    width: 160,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  }
];
